import React, {useRef} from 'react';
import Styled from 'styled-components';
import {Button} from 'web-components';
import {createToast} from '../../../../toasts/toast';
import {CSS_CONSTANTS} from '../../../../../../../css_variables';
import Util from '../../../../../util/util';
import * as tracking from '../../../../../../../tracking';
import {VARIANT} from '../../../../../../../containers/modal/project-automate/project_automate_modal';
import CreateTaskDismissedNotification from '../../../../../../../mutations/CreateTaskDismissedNotification';
import UpdateTaskMutation from '../../../../../../../mutations/update_task_mutation.modern';

const PredictionPopupWrapper = Styled.div`
    cursor: initial;
`;

const PredictionPopupText = Styled.div`
    font-size: 13px;
    color: ${CSS_CONSTANTS.v2_text_gray};
    white-space: normal;
    font-weight: 400;
    margin-bottom: 8px;
`;

const PredictionPopupTextBold = Styled(PredictionPopupText)`
    font-weight: 500;
`;

const ButtonGroup = Styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 8px 0;
	button:not(:first-child) {
		margin-left: 4px;
	}
`;

const getPredictionToast = (predictionApplied, intl) => {
	return () => createToast({duration: 5000, message: intl.formatMessage({id: predictionApplied ? 'common.prediction_applied' : 'common.prediction_discarded'})});
};

const handleEstimationChanges = (val, task, intl) => {
	if (isNaN(val)) return;

	const mutation = {
		ids: [task.id],
		estimateLow: val,
		estimateHigh: val,
		forecast: val,
	};
	if (task.estimateForecast === val) return;
	tracking.trackAIEvent('Prediction applied', VARIANT.ESTIMATES);
	Util.CommitMutation(UpdateTaskMutation, mutation, getPredictionToast(true, intl));
};

const handleNotificationDismissed = (task, intl) => {
	const mutation = {
		taskIds: [task.id],
		eventType: 'TASK_OVERRUN',
	};
	tracking.trackAIEvent('Prediction dismissed', VARIANT.ESTIMATES);
	Util.CommitMutation(CreateTaskDismissedNotification, mutation, getPredictionToast(false, intl));
};

export const PredictionPopup = ({predictedEstimate, task, modelScore = 0, intl}) => {
	const {formatMessage} = intl;
	const optionSelected = useRef(false);

	const handleCallback = positive => {
		if (!optionSelected.current) {
			optionSelected.current = true;

			if (positive) {
				handleEstimationChanges(predictedEstimate, task, intl);
			} else {
				handleNotificationDismissed(task, intl);
			}
		}
	};

	return (
		<PredictionPopupWrapper>
			<PredictionPopupTextBold>{formatMessage({id: 'common.task_predicted_overrun'})}</PredictionPopupTextBold>
			<PredictionPopupText>{formatMessage({id: 'common.prediction_similar_tasks_took'}, {value: Util.convertMinutesToFullHour(predictedEstimate, intl)})}.</PredictionPopupText>
			<ButtonGroup>
				<Button variant={Button.VARIANT.PURPLE_OUTLINE} onClick={() => handleCallback(false)}>
					{formatMessage({id: 'common.discard_prediction'})}
				</Button>
			</ButtonGroup>
		</PredictionPopupWrapper>
	);
};
